<template>
    <div class="bottom-operate-wrap">
        <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck" />
        <label class="all-label" for="allCheckBox">{{ allLabel }}</label>
        <span class="total-number"
            >{{ $t("zhiji.cluster.closeLoop.totalOf") }}<i>{{ total }}</i> {{ $t("zhiji.cluster.closeLoop.pages") }}</span
        >
        <Button class="btn" :text="linkedBtn" @btnClick="linkedHandler"></Button>
        <Button class="btn" :text="deleteBtn" :icon="deleteIcon" :hoverIcon="deleteHoverIcon" @btnClick="deleteHandler"></Button>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "BottomOperateBar",
    props: ["total", "allCheck"],
    components: {
        Checkbox,
        Button
    },
    data() {
        return {
            deleteIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
            deleteHoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px"
        };
    },
    computed: {
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        },
        deleteBtn() {
            return this.$t("zhiji.common.delete");
        },
        linkedBtn() {
            return this.$t("zhiji.cluster.closeLoop.linkSimilar");
        }
    },
    methods: {
        allCheckHandler(data) {
            this.$emit("allCheckChange", data);
        },
        linkedHandler(e) {
            this.$emit("linkedClick", e);
        },
        deleteHandler(e) {
            this.$emit("deleteClick", e);
        }
    }
};
</script>

<style scoped lang="scss">
.bottom-operate-wrap {
    display: flex;
    align-items: center;
    background: #fafbfd;
    padding: 16px 20px;
    font-size: 12px;

    .all-check {
        margin-right: 12px;
    }
    .total-number {
        margin: 0 15px;
    }
    .total-number {
        color: #7c8296;
        & > i {
            color: #00c972;
            font-style: normal;
            margin: 0 2px;
        }
    }
    .btn {
        margin-right: 10px;
    }
}
</style>
